import styled from 'styled-components';
import { Collapse, Space, Tag } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import IconButton from 'components/new-ui/base/icon-button/IconButton';
import { StyledIconWrapper } from 'components/new-ui/base/page-header/styles';
import SuitCaseIcon from 'components/icons/SuitCaseIcon';
import { ErrorLabel } from 'components/new-ui/composed/formInput/styles';
import DocumentItem from './DocumentRow';
import { EmailJobData } from 'store/jobs/types';

const { Panel } = Collapse;

const FILE_TYPE_ORDER = ['CLEARANCE_SLIP', 'SAD', 'COMMERCIAL_INVOICE'] as const;

const StyledCollapse = styled(Collapse)`
    .ant-collapse-content-box {
        padding: 0 !important;
    }
    .ant-collapse-header {
        padding: 0 !important;
    }
`;

type Props = {
    job: EmailJobData;
    onRemoveJobFromEmail?: (jobId: string | undefined) => void;
};

type PProps = {
    current: number;
    expected: number;
    status: 'success' | 'warning';
};
const NumberOfDocumentsTag = ({ current, expected, status }: PProps) => {
    return (
        <Tag style={{ userSelect: 'none' }} color={status}>
            {current}/{expected} Documents
        </Tag>
    );
};

const CollapsibleJob = ({ job, onRemoveJobFromEmail }: Props) => {
    const isError = job.summary.availableFileCount < 1;

    return (
        <li>
            <StyledCollapse
                ghost
                expandIcon={() => null}
                style={{ padding: 0, border: isError ? '1px solid red' : undefined }}
            >
                <Panel
                    key={1}
                    header={
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%',
                            }}
                        >
                            <Space size={6}>
                                <StyledIconWrapper style={{ width: 24, height: 24, fontSize: 14, borderRadius: 6 }}>
                                    <SuitCaseIcon />
                                </StyledIconWrapper>
                                <span>{job.jobReferenceId}</span>
                            </Space>

                            <Space size={6}>
                                <NumberOfDocumentsTag
                                    status={
                                        job.summary.availableFileCount !== job.summary.expectedFileCount
                                            ? 'warning'
                                            : 'success'
                                    }
                                    current={job.summary.availableFileCount}
                                    expected={job.summary.expectedFileCount}
                                />

                                <IconButton
                                    tooltipText="Remove Job"
                                    icon={<DeleteOutlined onClick={() => onRemoveJobFromEmail?.(job.jobId)} />}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}
                                />
                            </Space>
                        </div>
                    }
                >
                    <ul
                        style={{
                            listStyle: 'none',
                            paddingLeft: 32,
                            paddingBlock: 8,
                        }}
                    >
                        <Space style={{ width: '100%' }} direction="vertical" size={10}>
                            {job.declarations?.flatMap((dec) =>
                                [...dec.files]
                                    .sort((a, b) => FILE_TYPE_ORDER.indexOf(a.type) - FILE_TYPE_ORDER.indexOf(b.type))
                                    .map((file) => (
                                        <DocumentItem
                                            key={`${dec.declarationId}-${file.type}`}
                                            fileName={file.fileName}
                                            documentType={file.type}
                                            documentStatus={file.status === 'FINAL' ? 'FINAL' : 'MISSING'}
                                        />
                                    ))
                            )}
                        </Space>
                    </ul>
                </Panel>
            </StyledCollapse>
            {isError && (
                <ErrorLabel>
                    No documents are avaialble for this job. Please remove it from the email to proceed.
                </ErrorLabel>
            )}
        </li>
    );
};

export default CollapsibleJob;
